import React from 'react';
import { fromApi } from '../kit/time';

// Ticket 154: shown when the server says the fast GHL pull has stalled, so a
// quiet Inbox is not mistaken for "no new messages". One line at 390 px.
export default function LivePausedNotice({ live }) {
  if (live?.state !== 'paused') return null;
  let text = 'Live updates paused.';
  if (live.last_ok_at) {
    const mins = Math.max(0, Math.floor((Date.now() - fromApi(live.last_ok_at).getTime()) / 60000));
    text = `Live updates paused. Last checked ${mins} minute${mins === 1 ? '' : 's'} ago.`;
  }
  return (
    <div
      role="status"
      data-testid="live-paused"
      className="px-3 py-1.5 text-xs bg-amber-50 text-amber-800 border-b border-amber-200 truncate flex-shrink-0"
    >
      {text}
    </div>
  );
}
